import { ActionRenderer, agActionRendererStyles } from '@genesislcap/grid-pro';
import { css, html } from '@microsoft/fast-element';
/**
 * @tagname %%prefix%%-grid-pro-action-renderer
 */
export class ZeroAgActionRenderer extends ActionRenderer {
}
/**
 * The Zero Action Renderer
 *
 * @public
 * @remarks
 * HTML Element: \<zero-grid-pro-action-renderer\>
 */
export const zeroAgActionRenderer = ZeroAgActionRenderer.compose({
    baseName: 'grid-pro-action-renderer',
    styles: css `
    ${agActionRendererStyles}
  `,
    template: html `
    <div class="action-container" part="action-container">
      <zero-button
        class="action-renderer"
        part="action-renderer"
        aria-label=${(x) => x.params.actionName}
        data-test-id="${(x) => x.dataTestId}"
        ?disabled=${(x) => { var _a; return x.pendingAction || x.isDisabled((_a = x.params) === null || _a === void 0 ? void 0 : _a.data); }}
        appearance="${(x) => x.params.appearance}"
        @click=${(x) => x.clickHandler()}
      >
        ${(x) => x.params.contentTemplate
        ? html `
                ${x.params.contentTemplate}
              `
        : x.params.actionName}
      </zero-button>
    </div>
  `,
});
